import type { Component } from 'vue';

// Importar los componentes estandar internos de la libreria
import QuestionContact from '../components/Options/QuestionContact.vue';
import QuestionFile from '../components/Options/QuestionFile.vue';
import QuestionMap from '../components/Options/QuestionMap.vue';
import QuestionRadio from '../components/Options/QuestionRadio.vue';
import QuestionSelect from '../components/Options/QuestionSelect.vue';
import QuestionText from '../components/Options/QuestionText.vue';
import QuestionAsyncData from '../components/Options/QuestionAsyncData.vue';
import QuestionSignature from '../components/Options/QuestionSignature.vue';

type ComponentRegistry = Record<string, Component>;

// El registro interno pre-cargado con las preguntas de base
const registry: ComponentRegistry = {
  radio: QuestionRadio,
  select: QuestionSelect,
  text: QuestionText,
  textarea: QuestionText,
  number: QuestionText,
  email: QuestionText,
  file: QuestionFile,
  map: QuestionMap,
  contact_number: QuestionContact,
  async_data: QuestionAsyncData,
  signature: QuestionSignature,
};

export const QuestionFactory = {
  /**
   * Obtiene la instancia del Componente de Vue asociado al tipo.
   * Si el tipo no existe en el registro, hace un fallback al tipo 'text' por seguridad.
   */
  getComponent(type: string): Component {
    return registry[type] || registry['text'];
  },

  /**
   * Permite que aplicaciones externas (ej. Frontends) registren dinamicamente 
   * nuevos componentes de preguntas sin bifurcar el codigo de procedures-engine.
   * @param type La key que llega desde la Base de Datos (ej: 'signature_pad')
   * @param component Tu Componente Vue importado
   */
  registerComponent(type: string, component: Component): void {
    if (registry[type]) {
      console.warn(`[ProceduresEngine] Sobrescribiendo el componente para el tipo: ${type}`);
    }
    registry[type] = component;
  },

  /**
   * Devuelve todos los tipos registrados actualmente.
   */
  getRegisteredTypes(): string[] {
    return Object.keys(registry);
  },
  
  /**
   * Chequea si un tipo tiene componente asignado explícitamente sin invocar el fallback.
   */
  hasComponent(type: string): boolean {
    return !!registry[type];
  }
};
